import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

@Component({
	selector: 'chips',
	templateUrl: './chips.component.html',
	styleUrls: ['./chips.component.css']
})
export class ChipsComponent implements OnInit {


	@Input() dataset = []
	@Input() dataattr: string = ''
	@Input('datatags') tags = []
	@Input() strict: boolean = false
	@Input() limit: number = -1

	@Output() valueChanged = new EventEmitter()


	constructor() { }

	ngOnInit() {
	}

	//tags = []
	model = ''

	destroyMe(id: number) {
		this.tags.splice(id, 1)
	}

	doCreateTag(e) {

		if (e.key == 'Backspace' && this.tags.length > 0 && this.model.length <= 0) {
			this.tags.splice(this.tags.length - 1, 1)
			this.valueChanged.emit(this.tags)
		}

		if (this.limit > 0 && this.tags.length >= this.limit) {
			this.model = ''
			return
		}

		if (e.key == 'Enter' && this.model.length > 2) {

			let r = this.findLbl(this.dataattr, this.model)
			//console.log(r)

			if (r < 0 && this.strict) {
				this.model = ''
				return
			}

			// Find dup
			for (var i = 0; i < this.tags.length; i++) {
				//console.log(this.tags[i], this.model)
				if (this.tags[i] == this.model) {
					return
				} else if (this.tags[i][this.dataattr] == this.model) {
					return
				}
			}

			if (r >= 0 && this.dataset[r]) {
				this.tags.push(this.dataset[r])
				this.valueChanged.emit(this.tags)
			} else {

				if (this.dataattr) {
					this.tags.push({name: this.model})
					this.valueChanged.emit(this.tags)
					//this.clearDuplicates()
				} else {
					this.tags.push(this.model)
					this.valueChanged.emit(this.tags)
				}

			}

			this.model = ''
		}
	}

	findLbl(name, value) {
		for (var i = 0; i < this.dataset.length; i++) {
			if (this.dataset[i][name] == value) {
				return i
			}
		}
		return -1
	}

	clearDuplicates() {
		return this.tags.filter((tag, index, self) => self.findIndex((t) => {
			return (this.dataattr ? t[this.dataattr] : t) === (this.dataattr ? tag[this.dataattr] : tag) 
		}) === index)
		//console.log(v)
		// this.tags = this.tags.filter((tag, index, self) => self.findIndex((t) => {
		// 	return (this.dataattr ? t[this.dataattr] : t) === (this.dataattr ? tag[this.dataattr] : tag) 
		// }) === index)

	}

	search = (text$: Observable<string>) => {
		return text$
			.debounceTime(200)
			.distinctUntilChanged()
			.map(term => term.length < 2 ? [] : this.dataset.filter(v => {
				return new RegExp(term, 'gi').test(this.dataattr ? v[this.dataattr] : v)
			}).splice(0, 10))
			.map(txt => txt.map(ttx => this.dataattr ? ttx[this.dataattr] : ttx))
	}

}



// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/components/chips/chips.component.ts